module.exports = __webpack_public_path__ + "static/img/ic_home_banner.2711465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_home_banner.png
// module id = F0oC
// module chunks = 1